import type { PaginationMeta } from '@core/http-types';
import type { IconName } from '@core/user-interface-legacy';

export const isAllPagesLoaded = (pagination: PaginationMeta) =>
  pagination.totalCount <= pagination.page * pagination.limit;

const LEGACY_EMPTY_STATE_ICONS: Record<string, IconName> = {
  profile_icon: 'users',
};

export const normalizeEmptyStateIcon = (icon: IconName): IconName =>
  LEGACY_EMPTY_STATE_ICONS[icon] ?? icon;

export const isFilteredEmptyState = (
  isViewPredefined: boolean,
  filtersApplied: boolean,
  filtersChanged: boolean,
): boolean => {
  if (!isViewPredefined && filtersApplied) return true;

  return isViewPredefined && filtersChanged;
};
